import { isInheritedDiscountItemPrice, isInheritedDiscountPriceAvailable, isInheritedMemberRewardItemPrice, isInheritedMemberRewardPriceAvailable } from './item-price-utils';
export const getInheritedPriceForItemModifier = (baseItem, modifier) => {
    return modifier.prices.find(itemPrice => {
        if (isInheritedMemberRewardItemPrice(itemPrice)) {
            return isInheritedMemberRewardPriceAvailable(itemPrice, baseItem);
        }
        if (isInheritedDiscountItemPrice(itemPrice)) {
            return isInheritedDiscountPriceAvailable(itemPrice, baseItem);
        }
        return false;
    });
};
